import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { getErrorMessage } from '@/api/api-client'
import { useDeleteMyAccount } from '@/api/user/mutations/useDeleteMyAccount'
import { ConfirmDialog } from '@/components/ConfirmDialog'
import { Button } from '@/components/ui/button'
import { RoutePath } from '@/RoutePath'

export function DeleteAccountSection() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [error, setError] = useState('')
  const { mutate, isPending } = useDeleteMyAccount()

  const onConfirm = () => {
    setError('')
    mutate(undefined, {
      onSuccess: () => {
        setIsOpen(false)
        navigate(RoutePath.Login, { replace: true })
      },
      onError: err => {
        setError(getErrorMessage(err) || t('native.deleteAccountError'))
      },
    })
  }

  return (
    <div className='space-y-3 rounded-2xl border border-red-100 bg-white p-6'>
      <h2 className='text-text-primary text-base font-medium'>{t('native.deleteAccountTitle')}</h2>
      <p className='text-text-secondary text-sm'>{t('native.deleteAccountBody')}</p>
      {error ? <p className='text-sm text-red-600'>{error}</p> : null}
      <Button type='button' variant='destructive' onClick={() => setIsOpen(true)}>
        {t('native.deleteAccountButton')}
      </Button>
      <ConfirmDialog
        isOpen={isOpen}
        title={t('native.deleteAccountConfirmTitle')}
        content={t('native.deleteAccountConfirmBody')}
        confirmText={t('native.deleteAccountConfirm')}
        cancelText={t('native.deleteAccountCancel')}
        confirmLoading={isPending}
        onConfirm={onConfirm}
        onClose={() => setIsOpen(false)}
      />
    </div>
  )
}
